/**
 * 接口统一集成模块
 */
// import * as login from './modules/login'  // 登录模块

import * as menu from './modules/menu'
import * as user from './modules/user'
import * as club from './modules/club'
import * as clubExamines from './modules/examines/clubExamines'
import * as examinStandard from './modules/examines/examinStandard'
import * as nation from './modules/examines/nation'
import * as students from './modules/examines/studentList'
import * as examinGroup from './modules/examines/examinGroup'
import * as grade from './modules/examines/grade'
import * as examinRecord from './modules/examines/examinRecord'
import * as venuePhotoType from './modules/venue/venuePhotoType'
import * as matchProgram from './modules/match/matchProgram'
import * as agencyVenue from './modules/venue/agencyVenue'

// 默认全部导出
export default {
  menu,
  user,
  club,
  clubExamines,
  examinStandard,
  nation,
  students,
  examinGroup,
  grade,
  examinRecord,
  venuePhotoType,
  matchProgram,
  agencyVenue
}



// WEBPACK FOOTER //
// ./src/http/api.js